import { forwardRef, useImperativeHandle, useState } from 'react';
import { Button, Modal } from "antd";
import { langCommon } from "../../../locales";
import 'react-quill/dist/quill.snow.css';

export const ViewModal = forwardRef((props: any, ref: any) => {
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>();

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any) => {
        if (typeof val !== 'boolean') {
            setFormData(val);
        }
        setVisiable(!!val);
    }

    return (
        <div>
            <Modal
                title={formData?.Title}
                width={900}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                footer={() => {
                    return <Button type='primary' onClick={() => changeVisible(false)} >{langCommon?.confirm}</Button>
                }}
            >
                <div className="ql-container ql-snow" style={{ border: 0 }}>
                    <div className="ql-editor">
                        <div dangerouslySetInnerHTML={{ __html: formData?.Content }}></div>
                    </div>
                </div>
            </Modal>
        </div>
    );
})
